/* eslint-disable jsx-a11y/label-has-associated-control */
// 外部からメール受信した際の登録・削除ページ

/*-------------------
    モジュールのimport
---------------------*/
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import axios from 'axios';
/*-------------------
    classのimport
---------------------*/
import * as commons from '../commons';
import Footer from '../components/Footer';
/*-------------------
    cssのimport
---------------------*/
import '../css/safety.css';

import { AAMAIL_PATH } from '../constant/constant';

// クラス名
class SafetyRegist extends Component {
  constructor(props) {
    super(props);

    // URLから安心安全メールのコードを取得。
    const url = props.location.pathname;
    const num = url.lastIndexOf('/');
    const tmpUrl = url.slice(num + 1);
    this.state = {
      tmpUrl,
      agreeFlag: false,
      areaChoice: [],
      groupInfo: [],
      insertCode: [],
      errMsg: '',
    };
  }

  componentDidMount = async () => {
    const { tmpUrl = '' } = this.state;

    // 乱数から仮登録の設定を取得する。
    const tmpData = await axios
      .post(`${AAMAIL_PATH}/p/v1/rgst`, { tmpUrl })
      .then((res) => res.data)
      .catch(() => {
        window.alert('データの取得に失敗しました。');
        return [];
      });
    const { resData, kind } = tmpData;

    // 存在しないURLの場合は404へ飛ばす
    if (kind === '-1') {
      commons.moveErrorPage(this.props, '10');
      return;
    }

    const {
      registKind: tmpKind,
      siteName,
      address,
      company,
      faxNum,
      mailAddress,
      telNum,
      insertCode,
      groupInfo,
      cryptUrl,
      useRule,
    } = resData;

    // フッター作成
    const footer = (
      <>
        <div className="mt20">{`お問合せは${company}までご連絡ください。`}</div>
        {address === '' ? null : <div>{address}</div>}
        {telNum === '' ? null : <div>{`Tel：${telNum}`}</div>}
        {faxNum === '' ? null : <div>{`Fax：${faxNum}`}</div>}
        {mailAddress === '' ? null : (
          <div>
            {`e-Mail：`}
            <a href={`mailto:${mailAddress}`}>{mailAddress}</a>
          </div>
        )}
      </>
    );

    const registKind = kind === '1' ? tmpKind : '-1';

    const insertValue = [];
    for (let i = 0; i < insertCode.length; i += 1) {
      const { code } = insertCode[i];
      insertValue.push({ code, name: '' });
    }

    this.setState({
      siteName,
      registKind,
      insertCode,
      insertValue,
      groupInfo,
      cryptUrl,
      useRule,
      footer,
    });
  };

  // 期限切れページの作成
  createNothingCont = () => (
    <div className="txtCenter mt20 mb30">
      このURLは無効です。
      <br />
      有効期限が切れています。
      <br />
      再度、
      <button
        type="button"
        className="btnAtag"
        onClick={() => {
          this.onClickBtnMove('../home');
        }}
      >
        トップページ
      </button>
      から申込みを行ってください
    </div>
  );

  // 利用規約ページの作成
  createAgreeCont = () => {
    const { useRule, agreeFlag } = this.state;

    return (
      <div>
        <div className="safety-top">
          <h2>利用規約</h2>
        </div>
        <div className="safety-exposition mt20">
          <ul>{commons.shapedContents(useRule, '1')}</ul>
        </div>
        <div className="txtCenter mb10">
          上記内容を呼んで同意いただける場合は
          <br />
          「同意する」にチェックをして「次へ」ボタンをクリックしてください
          <br />
          <label htmlFor="id02">
            <input
              type="checkbox"
              id="id02"
              onChange={() => {
                this.setState({ agreeFlag: !agreeFlag });
              }}
            />
            &nbsp; 同意する
          </label>
          <br />
          <button
            type="button"
            className="btn safety-btn mt20"
            disabled={!agreeFlag}
            onClick={() => {
              this.setState({ registKind: '01' });
            }}
          >
            次へ
          </button>
        </div>
      </div>
    );
  };

  // チェックボックスに値を追加する。
  checkChange = (id) => {
    const { areaChoice } = this.state;
    const tmpNum = areaChoice.indexOf(id);
    if (tmpNum > -1 && id === -1) {
      this.setState({ areaChoice: [] });
    } else if (id === -1) {
      this.setState({ areaChoice: [-1] });
    } else if (tmpNum > -1) {
      areaChoice.splice(tmpNum, 1);
      this.setState({ areaChoice: [...areaChoice] });
    } else {
      areaChoice.push(id);
      this.setState({ areaChoice: [...areaChoice] });
    }
  };

  // 配信地区の選択欄作成
  createGroupList = () => {
    const { groupInfo, areaChoice } = this.state;

    if (groupInfo.length === 0) return null;

    // 各地区のチェックボックスを作成
    const rowContent = [];
    for (let i = 0; i < groupInfo.length; i += 1) {
      const { name, id } = groupInfo[i];
      rowContent.push(
        <tr key={`check_${i}`}>
          <td>
            <input
              type="checkbox"
              id={`check_${i}`}
              checked={areaChoice.indexOf(id) > -1}
              onChange={() => this.checkChange(id)}
              disabled={areaChoice.indexOf(-1) > -1}
            />
          </td>
          <td>
            <label htmlFor={`check_${i}`}>&nbsp;{name}</label>
          </td>
        </tr>
      );
    }

    return (
      <div className="mb20">
        <span style={{ color: 'red' }}>（必須）</span>受信を希望するグループを選択してください
        <table style={{ margin: 'auto' }}>
          <tr>
            <td>
              <input
                className="mb20 mt20"
                type="checkbox"
                id="check_all"
                onChange={() => this.checkChange(-1)}
                checked={areaChoice.indexOf(-1) > -1}
                readOnly
              />
            </td>
            <td>
              <label htmlFor="check_all">&nbsp;すべて選択</label>
            </td>
          </tr>
          {rowContent}
        </table>
      </div>
    );
  };

  // 差し込みコード入力欄を作成する。
  changeInsertCode = (value, num) => {
    const { insertValue } = this.state;
    insertValue[num].name = value;
    this.setState({ ...insertValue });
  };

  createInsertList = () => {
    const { insertCode } = this.state;

    if (insertCode.length === 0) return null;

    const resTable = [];
    for (let i = 0; i < insertCode.length; i += 1) {
      const { name } = insertCode[i];
      resTable.push(
        <tr key={`insertCode_${i}`}>
          <td className="pr10" style={{ textAlign: 'right' }}>
            {name}
          </td>
          &nbsp;
          <td>
            <input
              type="text"
              onBlur={(e) => {
                this.changeInsertCode(e.target.value, i);
              }}
            />
          </td>
        </tr>
      );
    }

    return (
      <div className="mb20">
        （任意）メール送信の際に、配信内容によって以下で設定した内容が使用されます。
        <table style={{ margin: 'auto' }} className="mt10">
          <tbody>{resTable}</tbody>
        </table>
      </div>
    );
  };

  // 登録ページの作成
  createInsertCont = () => {
    const { siteName } = this.state;

    return (
      <div className="txtCenter">
        {this.createGroupList()}
        {this.createInsertList()}
        {`${siteName}への本登録を行います。`}
        <br />
        よろしいですか？
        <br />
        <button
          type="button"
          className="btn safety-btn mt20"
          onClick={() => {
            this.addAddress();
          }}
        >
          はい
        </button>
      </div>
    );
  };

  // 削除ページの作成
  createDeleteCont = () => {
    const { siteName } = this.state;

    return (
      <div className="txtCenter">
        {`${siteName}の登録解除を行います。`}
        <br />
        よろしいですか？
        <br />
        <button
          type="button"
          className="btn safety-btn mt20"
          onClick={() => {
            this.delAddress();
          }}
        >
          はい
        </button>
      </div>
    );
  };

  // アドレスの登録を行う。
  addAddress = async () => {
    const { areaChoice = [], insertValue = [], tmpUrl, groupInfo } = this.state;

    if (areaChoice.length === 0 && groupInfo.length > 0) {
      this.setState({ errMsg: `グループを選択して下さい` });
      return;
    }

    const resData = await axios
      .post(`${AAMAIL_PATH}/p/v1/rgst/c`, { areaChoice, insertValue, tmpUrl })
      .catch(() => false);

    if (resData === false) this.setState({ registKind: '-2', errMsg: `` });
    this.setState({ registKind: '02', errMsg: `` });
  };

  // アドレスの削除を行う。
  delAddress = async () => {
    const { tmpUrl } = this.state;

    const resData = await axios.post(`${AAMAIL_PATH}/p/v1/rgst/d`, { tmpUrl }).catch(() => false);

    if (resData === false) this.setState({ registKind: '-2' });
    this.setState({ registKind: '12' });
  };

  onClickBtnMove = (path) => {
    const { cryptUrl } = this.state;
    const { history } = this.props;
    history.push({ pathname: `${path}/${cryptUrl}` });
  };

  render() {
    const { siteName, registKind = '', footer, errMsg } = this.state;

    return (
      <div id="safety-container">
        <div className="safety-back">
          <div className="safety-title">{siteName}</div>
          <div className="safety-content">
            {registKind === '-2' ? (
              <div className="txtCenter mt20 mb30">
                システムエラーが発生しました
                <br />
                ご迷惑をおかけしますが、以下のお問い合わせ先にご連絡お願いします
              </div>
            ) : null}
            {registKind === '-1' ? this.createNothingCont() : null}
            {registKind === '0' ? this.createAgreeCont() : null}
            {registKind === '01' ? this.createInsertCont() : null}
            {registKind === '02' ? (
              <div className="txtCenter mt20 mb30">{`${siteName}への本登録が完了しました`}</div>
            ) : null}
            {registKind === '1' ? this.createDeleteCont() : null}
            {registKind === '12' ? (
              <div className="txtCenter mt20 mb30">{`${siteName}の登録解除が完了しました`}</div>
            ) : null}
            {errMsg === '' ? null : <div className="notice alertFault mt10">{errMsg}</div>}
            <div className="safety-fot">{footer}</div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

SafetyRegist.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default withRouter(SafetyRegist);
